import React from "react"
import { Controller, useForm } from "react-hook-form"
import { CreateSubcategoriasGastosInput } from "src/gql/schema"
import HeaderIcon from "src/shared/components/data-display/header-icon/HeaderIcon"
import { Button, InputText } from "src/shared/components/forms"
import { Modal } from "src/shared/components/layout/modal/Modal"
import DocFill from "src/shared/icons/DocFill"
import "./AddSubCat.css"
import useSnackbar from "src/shared/hooks/useSnackbar"
const defaultValues: CreateSubcategoriasGastosInput = {
    categoria_id: "",
    subcategoria: "",
}

function firstRepeated(values: string[]): string | false {
    const seen = new Set<string>();

    for (const value of values) {
        if (seen.has(value)) {
            return value;
        }
        seen.add(value);
    }

    return false;
}
interface AddSubCatProps {
    id: string
    onClose: () => void
    onSub: (subcat_names: string) => void
    newSubcategoryList: string[]
    subCategorias: any[]
}
const AddSubCat = ({ id, onClose, onSub, newSubcategoryList, subCategorias }: AddSubCatProps) => {

    const { showSnackbar } = useSnackbar()

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({ defaultValues })

    const onSubmit = (data: CreateSubcategoriasGastosInput) => {
        const repeated = firstRepeated([...newSubcategoryList, ...subCategorias.map((c) => c.subcategoria), data.subcategoria])

        if (repeated) {
            showSnackbar({
                status: "error",
                text: `La subcategoria **${repeated}** ya se encuentra registrada`,
                title: "Error al crear subcategorías"
            })
            return onClose?.()
        }
        onSub(data.subcategoria)
        showSnackbar({
            status: "success",
            title: "Subcategoría creada",
            text: `La subcategoría **${data.subcategoria}** ha sido creada exitosamente`
        })
        onClose?.()
    }
    return (
        <Modal
            isOpen={true}
            onClose={onClose}
            withCloseButton
            isCancelableOnClickOutside={true}
            width={572}
            className="add-sub-categoria-modal"
        >
            <HeaderIcon
                title="Nueva subcategoría de gastos"
                subTitle="Ingresa los datos que se piden a continuación"
                icon="docs"
            />
            <form className="add-sub-categoria-modal__form" onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    control={control}
                    name={"subcategoria"}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                        <InputText
                            error={errors.subcategoria ? true : false}
                            style={{ width: "100%" }}
                            autoFocus
                            errorhinttext={errors.subcategoria ? "Escribe una subcategoría" : undefined}
                            className={"gasto-add-modal-form-input"}
                            label={"Nombre de la subcategoría"}
                            maxLength={50}
                            type={"text"}
                            placeholder={"Escribe nombre"}
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            icon={DocFill}
                        />
                    )}
                />
                <Button className="add-sub-categoria-modal__button" type={"submit"} text={"Crear subcategoria"} />
            </form>
        </Modal>
    )
}

export default AddSubCat
